import {createContext, type PropsWithChildren, use} from 'react'

export const NOTIFICATION_SUBSCRIPTION_PATH = '/notifications/thread'

const NotificationSubscriptionCsrfTokenContext = createContext<string | undefined>(undefined)

export function NotificationSubscriptionCsrfTokenProvider({
  token,
  children,
}: PropsWithChildren<{token: string | undefined}>) {
  return <NotificationSubscriptionCsrfTokenContext value={token}>{children}</NotificationSubscriptionCsrfTokenContext>
}

export function useNotificationSubscriptionCsrfToken() {
  return use(NotificationSubscriptionCsrfTokenContext)
}
